import React, { useContext, useState } from 'react';
import { Grid, Tab, Tabs } from '@mui/material';
import { LanguageContext } from '../../../../../../libs/Context';
import FeedCards from '../../FeedCards';
import { useSelector } from 'react-redux';
import useFeedApproval from '../../FeedCreation/CustomHooks/useFeedApproval';

export type Selected = 'tag' | 'schedule' | 'selfFeed' | 'pendingapproval';

interface MyActivityProps {
  searchVal: any;
  selectedFilter: any;
}

const MyActivity: React.FC<MyActivityProps> = ({ searchVal, selectedFilter }) =>
{
	const [ selected, setSelected ] = useState<Selected>('selfFeed');
	const { language } = useContext(LanguageContext);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const { isFeedsAdmin } = useFeedApproval();

	const handleChangeTabs = (_event: React.SyntheticEvent, newValue: Selected) =>
	{
		setSelected(newValue);
	};

	const tabStyle = (sel: Selected) => ({
		borderRadius    : 'var(--pixel20)',
		backgroundColor : selected === sel ? 'var(--primaryColor)' : 'var(--whiteColor)',
		color           : selected === sel ? '#FFF' : 'var(--primaryColor)',
		marginRight     : 'var(--pixel8)',
		fontSize        : 'var(--pixel14)',
		border          : selected === sel ? undefined : '1px solid var(--primaryColor)',
		padding         : '6px 16px',
		minHeight       : 'var(--pixel30)'
	});

	return (
		<Grid container height='100%'>
			<Tabs
				value={selected}
				onChange={handleChangeTabs}
				variant='scrollable'
				scrollButtons='auto'
				aria-label='activity-tabs'
				sx={{
					background           : 'var(--whiteColor)',
					p                    : 'var(--pixel16)',
					borderRadius         : '13px',
					width                : '100%',
					'.MuiTabs-indicator' : { display: 'none' }
				}}
			>
				<Tab label={language.MyPosts} value='selfFeed' style={tabStyle('selfFeed')} />
				{userData?.role !== 'individual' && <Tab label={language.MyTags} value='tag' style={tabStyle('tag')} />}
				<Tab label={language?.scheduled} value='schedule' style={tabStyle('schedule')} />
				{!isFeedsAdmin && userData?.role !== 'individual' && (
					<Tab
						label={language?.pendingApproval || 'Pending Approval'}
						value='pendingapproval'
						style={tabStyle('pendingapproval')}
					/>)}
			</Tabs>

			<Grid item mt={2} xs={12} height='100%' display='flex' alignItems='center'>
				<FeedCards
					key={selected}
					selectedActivity={selected}
					searchVal={searchVal}
					selectedFilter={selectedFilter}
				/>
			</Grid>
		</Grid>
	);
};

export default MyActivity;
